import { createContext } from 'react';

import type { TickAxis } from '../../core/utils/formatter-by-ticks.js';

export interface TimeseriesTickAxis {
  left: TickAxis;
  bottom: TickAxis;
  right?: TickAxis;
}

export const TimeseriesTickAxisContext = createContext<
  TimeseriesTickAxis | undefined
>(undefined);

TimeseriesTickAxisContext['displayName'] = 'TimeseriesTickAxisContext';
